import skinDetails from './skin-details-copy'

export default {
    skinDetails: skinDetails.ruRU,
    displayUi: {
        appearance: 'Оформление',
        charcoalCoral: 'Графит и коралл',
        envelopeTitle: 'Конверт с наградой',
        envelopeIntro: 'Откройте конверт, чтобы получить награду. Содержимое появится сразу.',
        selectDate: 'Выбрать дату',
        iosIntro: 'Следуйте видео и инструкциям, чтобы добавить приложение на главный экран.',
        iosMore: 'Выберите «Ещё».'
    },
    pwaGuide: {
        title: 'Установить приложение',
        intro: 'Следуйте инструкциям для вашего устройства.',
        iosBrowser: 'Через Safari',
        androidBrowser: 'Через браузер',
        iosStep1: 'Нажмите «Поделиться» на панели Safari.',
        iosStep2: 'Выберите «На экран «Домой»».',
        iosStep3: 'Нажмите «Добавить», чтобы завершить установку.',
        androidStep1: 'Откройте меню браузера в правом верхнем углу.',
        androidStep2: 'Выберите «Установить приложение» или «Добавить на главный экран».',
        androidStep3: 'Подтвердите установку.',
        add: 'Добавить',
        homeScreen: 'На экран «Домой»',
        menu: 'Меню браузера'
    },
    lang: {
        Close: 'Закрыть',
        LoadMore: 'Загрузить больше',
        AllLoaded: 'Все загружено',
        ChangeLanguage: 'Сменить язык',
        ChangePassword: 'Сменить пароль',
        copy: 'копия',
        copySuccess: 'Копирование успешно',
        copyError: 'Ошибка копирования',
        CopyEmptyTips: 'Скопированное содержимое не может быть пустым',
        empty: 'Здесь пусто',
        tips: 'Дружеское напоминание',
        cancel: 'Отмена',
        confirm: 'Подтвердить',
        more: 'Больше',
        isCloseGame: 'Вы хотите закрыть игру?',
        back: 'Назад',
        Claim: 'Получить',
        Loading: 'Загрузка',
        Play: 'Играть',
        Download: 'Скачать',
        NoData: 'Упс! Данных пока нет!',
        NoMore: 'Больше нет',
        CurrentlyPage: 'В настоящее время на этой странице',
        keywordPlaceholder: 'Введите название игры для поиска!',
        SearchGameByName: 'Искать название игры'
    },
    tabbar: {
        sport: 'sport',
        menu: 'меню',
        Lobby: 'Главная',
        Earn: 'Поделиться',
        Game: 'Игра',
        Event: 'БОНУСЫ',
        Promotion: 'БОНУСЫ',
        Account: 'Профиль',
        Recharge: 'Пополнить',
        serve: 'Служба',
        Deposit: 'Депозит',
        Affiliate: 'Партнёр'
    },
    home: {
        Download: 'Скачать',
        DownloadTips: 'Скачайте приложение и получите ',
        Search: 'Поиск',
        SearchGames: 'Поиск игр',
        Popular: 'Популярные',
        Recent: 'Недавние',
        Favorite: 'Избранное',
        Providers: 'ПРОВАЙДЕРЫ',
        CollectionSucc: 'Сбор успешно',
        CollectionCanceled: 'Сбор отменён',
        MORE: 'БОЛЬШЕ',
        Top: 'Топ',
        greatBonus: 'Отличный бонус за депозит',
        pullRefresh: 'Потяните вниз, чтобы обновить...',
        releaseRefresh: 'Отпустите, чтобы обновить...',
        loading: 'загрузка...',
        gameMoreTips1: 'Показать ',
        gameMoreTips2: ' игр из ',
        gameMoreTips3: ' игры'
    },
    login: {
        Login: 'Вход',
        SignIn: 'Войти',
        SignUp: 'Регистрация',
        RememberMe: 'Запомнить меня',
        ForgetPassword: 'Забыли пароль?',
        LoginTips: 'Чтобы посетить этот сайт, убедитесь, что вам больше 18 лет и вы согласны?',
        TermsOfService: 'Условия обслуживания',
        jumpRegister: 'Перейти к регистрации',
        JumpLogin: 'Перейти к входу',
        noAccountTips: 'У вас нет аккаунта?',
        hasAccountTips: 'У вас есть аккаунт?',
        Email: 'Электронная почта',
        VerificationCode: 'Код подтверждения',
        Send: 'Отправить',
        RestPassword: 'Сбросить пароль',
        passwordTips: 'Пароль (6-16)',
        passwordTips2: 'Введите пароль ещё раз',
        password: 'Пароль',
        phone: 'Номер телефона',
        ReferralCode: 'Реферальный код',
        CreateAccount: 'Создать аккаунт',
        PleaseEnterYourPhoneNumber: 'Пожалуйста, введите номер телефона',
        PleaseEnterYourPassword: 'Пожалуйста, введите ваш пароль',
        ThePasswordMustContain6To16Characters: 'Пароль должен содержать от 6 до 16 символов',
        InconsistentPassword: 'Пароли не совпадают',
        PleaseEnterInvitationCode: 'Пожалуйста, введите реферальный код',
        PleaseEnterEmail: 'Пожалуйста, введите вашу электронную почту',
        PleaseEnterEmailFormat: 'Пожалуйста, введите правильный формат электронной почты',
        day: 'день',
        also: 'также',
        downTime: 'Дата с момента запуска',
        changePwd: 'Сменить пароль',
        RechargeNow: 'Пополнить сейчас',
        PlayGame: 'Регистрация успешна! Играйте в игру~',
        serviceTips: 'Пожалуйста, сначала согласитесь с условиями обслуживания',
        SuccessfullyClaimed: 'Успешно получено',
        SuccessfullyClaimedTips1: '',
        SuccessfullyClaimedTips2: ' бонус будет зачислен на счёт',

        Account: 'Аккаунт',
        PleaseEnterAccount: 'Пожалуйста, введите аккаунт',
        AccountFormat: 'Ошибка формата аккаунта, 6-16 символов, поддерживает английские буквы/цифры',
        PhoneFormat: 'Формат введённого вами номера телефона неверен',
        PleaseEnterPassword: 'Пожалуйста, введите пароль',
        PasswordFormat: 'Не менее шести символов',
        ConfirmPassword: 'Подтвердите пароль',
        ConfirmPwdAgain: 'Подтвердите пароль ещё раз',
        InvitationCode: 'Реферальный код',
        PleaseEnteryourInvitationCode: 'Пожалуйста, введите ваш реферальный код',
        OverAgeAgree: 'Мне больше 18 лет, я прочитал и согласен',
        PleaseAgreeOverAge: 'Сначала отметьте соглашение пользователя',
        RememberYouraccountPassword: 'Запомните ваш пароль аккаунта',
        SelectCountry: 'Язык',

        Reminder: 'Напоминание',
        WantLogOutAccount: 'Вы хотите выйти из своего аккаунта?',
        ConfirmExit: 'Подтвердить выход',
        Cancel: 'Отмена',

        Strength: 'Сила',
        sixteenDigits: '8-16 символов',
        UpperCaseletters: 'Заглавные буквы',
        LowerCaseLetters: 'Строчные буквы',
        Numbers: 'Цифры',

        UNLOCK: 'РАЗБЛОКИРОВАТЬ',
        ENDLESSBENEFITS: 'БЕСКОНЕЧНЫЕ ПРЕИМУЩЕСТВА',
        loginTips1: 'Щедрые бонусы готовы! Присоединяйтесь к нам, найдите свои сокровища',
        loginTips2: 'Эксклюзивные VIP-события: выигрывайте по-крупному, делая ставки',
        loginTips3: 'Регулярно получайте денежные вознаграждения',
        loginTips4: 'Приглашайте друзей и зарабатывайте комиссионные за ставки',
        loginTips5: 'Ежедневные награды за вход',
        loginTips6: 'Бонус на первое пополнение: до 150%',
        loginTips7: 'Повысьте свой VIP-уровень, чтобы получить больше наград',
        loginTips8: 'Добро пожаловать в ',
        loginTips9: 'ПРИНЕСИТЕ вам беспрецедентный игровой опыт',
        accountOrPhone: 'Счет / номер телефона'
    },
    logout: {
        SignOut: 'Выйти',
        SignOutTips: 'Исследуйте мир, наполненный наградами и захватывающими играми!'
    },
    signin: {
        continua: 'continúa mañana',
        signInTitle: 'Ежедневный бонус за вход',
        signInDays: 'Непрерывный вход в течение ',
        days: ' дней',
        day: 'ДЕНЬ',
        claimed: 'Получено ',
        condition1: 'Требуемый депозит',
        condition2: 'Требуемые ставки',
        eventDetails: 'Детали события',
        checkin: 'Регистрация',
        CheckIn: 'ЗАРЕГИСТРИРОВАТЬСЯ',
        Today: 'Сегодня',
        Uncompleted: 'НЕЗАВЕРШЕНО',
        Completed: 'ЗАВЕРШЕНО',
        Conditions: 'Условия',
        Rules: 'Правила',
        titleTips: 'actual, has been received during',
        Recarregue: 'Recharge',
        Aposte: 'Aposte',
        desc1: 'The current level can log in with a total of',
        desc2: 'days and receive',
        upBonusTitle: 'Congratulations on receiving a daily bonus of',
        upBonusDesc1: 'Simply deposit',
        upBonusDesc2: 'to increase your reward by',
        upBonusDesc3: 'times',
        upBonusGetNow: 'Get now',
        upBonusGet: 'Get',
        upBonusRedeemSuccess: 'Redeemed successfully',
        upBonusRedeemMessage: 'receive',
        upBonusConfirm: 'Confirm',
        navTitle: 'Check-in',
        buttonCheckIn: 'Check-In',
        buttonUnavailable: 'Conditions not met',
        unavailable: 'Недоступно',
        levels: 'Уровни VIP',
        previousLevel: 'Предыдущий уровень',
        nextLevel: 'Следующий уровень'
    },
    share: {
        SelectPosterToSave: 'Выберите постер и сохраните изображение.',
        SocialShareTitle: 'Поделиться в социальных сетях',
        InviteFriendsTitle: 'Пригласите друзей',
        InvitationRewardTitle: 'Награда за приглашение',
        MaximumConfiguredReward: 'Максимальная настроенная награда',
        InvitationLinkTitle: 'Ваша пригласительная ссылка',
        ValidUsersRewardTitle: 'Активные пользователи и награды',
        InvitationPosterTitle: 'Постер приглашения',
        panel: 'Панель',
        FAQ: 'Часто задаваемые вопросы',
        TUTORIAL: 'УРОК',
        TotalRewards: 'Общие награды',
        TotalFriends: 'Всего друзей',
        inviteFriend: 'ПРИГЛАШАЙТЕ ДРУЗЕЙ, ЧТОБЫ ЗАРАБОТАТЬ',
        signUp: 'Зарегистрируйтесь и зарабатывайте',
        Commission: 'комисии',
        InviteVia: 'Пригласить через:',
        copy: 'Копировать',
        link: 'Ссылка',
        code: 'Код',
        or: 'ИЛИ',
        Rewards: 'Награды',
        title1: 'КОМИССИЯ',
        tip1: 'Заработайте до',
        tip2: 'комиссии, когда ваш друг делает ставки.',
        title2: 'КЭШБЭК ЗА ДЕПОЗИТ',
        tip3: 'Заработайте',
        tip4: 'когда ваш друг делает депозит.',
        Details: 'Детали',
        UncollectedCommissions: 'Несобранные комиссии',
        ExclusiveCommission: 'Эксклюзивная комиссия',
        DepositCashback: 'Кэшбэк за депозит',
        Claim: 'Получить',
        TodayTeamData: 'Данные команды за сегодня',
        TotalTeamData: 'Общие данные команды',
        SignUp: 'Регистрация',
        FirstDeposit: 'Первый депозит',
        ValidBet: 'Действительная ставка',
        LiveRewards: 'Живые награды',
        SendTotalCommission: 'Отправить общую комиссию',
        rules: 'Правила',
        ruleInfo: 'Вы можете зарабатывать деньги, приглашая друзей и получая до комиссионных вознаграждений!',
        Recommended: 'Рекомендуется',
        Month: 'Месяц',
        UnlimitedSubordinates: 'многоуровневая реферальная система',
        planTitle: 'УЗНАЙТЕ БОЛЬШЕ О НАШЕЙ ПАРТНЁРСКОЙ ПРОГРАММЕ',
        planInfo: 'Если у вас большая аудитория и подписчики. У нас есть специальные условия для вас, чтобы настроить вашу реферальную программу!',
        all: 'Все',
        Direct: 'Прямые',
        Indirect: 'Косвенные',
        TodayTeamIntro1: 'Зарегистрироваться: Количество пользователей, зарегистрировавшихся сегодня',
        TodayTeamIntro2: 'Первый депозит: Количество пользователей, сделавших первый депозит сегодня',
        TodayTeamIntro3: 'Действительные ставки: Действительные ставки для команды сегодня',
        TotalTeamIntro1: 'Зарегистрироваться: Общее количество регистраций команды',
        TotalTeamIntro2: 'Первый депозит: Общее количество пользователей, сделавших первый депозит',
        TotalTeamIntro3: 'Действительные ставки: Общая сумма действительных ставок команды',
        calculationRules: 'Правила расчёта комиссии',
        rewardRules: 'Правила вознаграждения комиссии',
        ExtendRewardsBouns: 'Расширенные бонусы вознаграждений',
        GameBettingRewardsBouns: 'Бонусы за ставки на игры',
        RechargeRewardsBouns: 'Бонусы за пополнение',
        Tier: 'Уровень',
        intro1: 'Зарегистрироваться: Количество пользователей, зарегистрировавшихся сегодня',
        intro2: 'Первый депозит: Количество пользователей, сделавших первый депозит сегодня',
        intro3: 'Действительные ставки: Действительные ставки для команды сегодня',
        intro4: 'Зарегистрироваться: Общее количество регистраций команды',
        intro5: 'Первый депозит: Общее количество пользователей, сделавших первый депозит',
        intro6: 'Действительные ставки: Общая сумма действительных ставок команды',
        rule1: ' Каждый раз, когда ваш рекомендованный игрок делает ставку, выигрывает или проигрывает, вы получаете разный процент комиссии.',

        startTime: 'Начинаем.',
        endTime: 'Конец',
        TotalRewardAmount: 'Общая сумма вознаграждения:',
        // rules: '',
        level: 'Уровень',
        Amount: 'Сумма',
        NumberOfPeople: 'Численность',
        Part1Blogger: 'Награды пользователей',
        FirstRewardAmount: 'Размер вознаграждения за членство первого уровня',
        FirstNumberOfPeople: 'Число действительных членов первого уровня',
        FirstRewardRatio: 'Процентная доля вознаграждения за действительное членство первого уровня',
        FirstPaymentDiff: 'Оплата членства первого уровня',
        FirstRechargeAmount: 'Членский капитал первого уровня',
        FirstWithdrawalAmount: 'Сумма, причитающаяся участникам первого уровня',
        Part2Partners: 'Вознаграждение партнеров',
        PartnerRewardAmount: 'Размер вознаграждения партнеров:',
        PartnerRechargeAmount: 'Сумма пополнения партнеров:',
        PartnerWithdrawalAmount: 'Сумма, предоставленная партнером:',
        FirstEffectiveNumber: 'Число активных партнеров первого уровня',
        SecondNumberOfPeople: 'Число действительных членов второго уровня',
        FirstPartnersRewardRatio: 'Процентная доля премий, выплачиваемых партнерам первого уровня',
        FirstPartnersRewardAmount: 'Размер вознаграждения для партнеров первого уровня',
        FirstPartnersPaymentDiff: 'Разница в оплате партнерами первого уровня',
        SecondEffectiveRechargeAmount: 'Активная сумма членства второго уровня',
        SecondEffectiveWithdrawalAmount: 'Эффективный взнос участника второго уровня',
        SecondRechargeAmount: 'Членский капитал второго уровня',
        SecondWithdrawalAmount: 'Взносы членов второго уровня',
        partnerRulesTips1_1: 'Совершенствование рекомендованного вознаграждения, увеличение доли прибыли рекомендованного лица, блоггер A рекомендует блоггера B, а A получает ',
        partnerRulesTips1_2: ' прибыли B',
        partnerRulesTips2: 'Правила партнёрства: 1000 ставок в неделю, 5000 действительных членов.',
        partnerRulesTips2_1: 'Правила партнёрства оплачиваются ',
        partnerRulesTips2_2: 'один раз в день. ',
        partnerRulesTips2_3: 'раз в неделю. ',
        partnerRulesTips2_4: 'Каждый месяц. ',
        partnerRulesTips2_5: 'При первом пополнении даже действительный член',
        partnerRulesTips2_6: 'Ставка ',
        partnerRulesTips2_7: ', ставка ',
        partnerRulesTips2_8: ' считается действительным членом',
        ReachStandard: 'Число лиц, достигших целевого показателя',
        RewardRatio: 'Процент вознаграждения',
        partner: 'Партнеры',
        LowerLevelTeamData: 'Данные нижестоящей команды',
        allData: 'Все данные',
        yesterday: 'Вчера',
        today: 'Сегодня',
        thisWeek: 'На этой неделе',
        lastWeek: 'На прошлой неделе',
        thisMonth: 'В этом месяце',
        lastMonth: 'В прошлом месяце',
        validBets: 'Действительные ставки',
        deposit: 'Депозит',
        myData: 'Мои данные',
        newSubordinates: 'Новые подчиненные',
        firstDeposits: 'Первые депозиты',
        firstDepositAmount: 'Сумма первого депозита',
        deposits: 'Депозиты',
        withdrawalValue: 'Сумма вывода',
        ValidBets: 'Действительные ставки',
        receiveBonuses: 'Получение бонусов',
        performance: 'Показатели работы',
        GLV: 'Сумма прибыли/убытка',
        commission: 'Комиссия',
        dataSummary: 'Сводка данных',
        agentDataTip: 'Сводка сегодняшних данных после становления агентом',
        teamSize: 'Размер команды',
        directMembers: 'Прямые участники',
        OtherMembers: 'Другие участники',
        fullPerformance: 'Полные показатели работы',
        direct: 'П. Прямой',
        others: 'П. других',
        totalCommissions: 'Общая комиссия',
        directCommission: 'Прямая комиссия',
        otherCommission: 'Другая комиссия',
        totalCommission: 'Общая комиссия',
        rescued: 'Востребовано',
        notCollected: 'Не востребовано',
        directDepositTotal: 'Общая сумма прямых депозитов',
        directSubordinateWithdrawalsTotal: 'Общая сумма выводов прямых подчиненных',
        directOrdersTotal: 'Общее количество прямых заказов',
        directValidBetsTotal: 'Общая сумма действительных ставок',
        directGainToatl: 'Накопленная сумма прямых прибылей и убытков',
        DirectRechargeAmount: 'Общая сумма прямых пополнений',
        OtherDeposits: 'Другие депозиты',
        FirstDirectRecharge: 'Первое прямое пополнение',
        OtherInitialRefills: 'Другие первые пополнения',
        TotalFirstDepositsPlayers: 'Общее количество игроков с первым депозитом',

        PromotedAccount: 'Продвигаемый аккаунт',

        HowInvite: 'Как пригласить',
        DailyInvitation: 'Ежедневное приглашение',
        WheelFortune: 'Колесо удачи',
        WheelFortuneTips: 'Пригласите друзей зарегистрироваться и пополнить счёт, чтобы получить награду до ',
        InvitationRules: 'Правила приглашений',
        ShareLinksTips: 'Поделитесь ссылками через социальные приложения',
        CopyLinkToFriends: 'Скопируйте ссылку приглашения и отправьте её друзьям.',
        InviteValidUsers: 'Приглашайте действительных пользователей',
        getRewardsTimeTips: 'Награды будут распределены в 00:00 на следующий день.',
        EarnRewards: 'Зарабатывайте награды',
        ImportantNotice: 'Важное уведомление:',
        ImportantNoticeContent: ' Чтобы обеспечить беспристрастность на платформе, мы приняли меры против обмана. Пользователи, замеченные в обмане, получат постоянную блокировку аккаунта, их незаконные средства будут заморожены, а они сами привлечены к юридической ответственности.',

        rule2: '🎉 Приглашение с наградами 🎉',
        rule3: '🔥 Приглашай друзей и зарабатывай без остановки!',
        rule4: '👉 📱 Когда твой друг зарегистрируется по номеру телефона и совершит первое пополнение счёта, он станет действительным пользователем.',
        rule5: '💎 За каждого действительного пользователя, которого ты пригласишь → ты получишь немедленную награду!',
        rule6: '🚀 Чем больше приглашений, тем больше заработка — нет ограничений!',
        rule7: '✨ Поделись прямо сейчас с друзьями и не упусти награды! 🎁🎊',

        Invite: 'пригласить',
        bonus: 'Премия',

        TotalPrize: 'Общий приз',
        BonusesAlreadySettled: 'Бонусы уже выплачены',
        BonusPendingSettlement: 'Бонус ожидает выплаты',
        UpdateEveryHours: 'Обновлять каждые 24 часа',
        TotalData: 'Общие данные',
        RewardsFirstRecharge: 'Награды за первое пополнение',
        TotalReward: 'Общая награда',
        DailyData: 'Дневные данные',
        Data: 'Данные',
        RechargeUser: 'Пополнить пользователя',
        FirstRechargeRewards: 'Награды за первое пополнение',
        AmountCollectedBehalf: 'Сумма депозита',
        CollectionPersonCount: 'Количество вкладчиков',
        SaveImage: 'Сохранить изображение',
        reward: 'премия'
    },
    deposit: {
        PaymentMethodsRregion: 'Способы оплаты для региона',
        DepositMethods: 'Способы депозита',
        Deposit: 'Депозит',
        FirstDeposit: 'Бонус на депозит',
        Details: 'Детали',
        Amount: 'Сумма',
        Extra: 'Дополнительно',
        noBonus: 'нет бонуса',
        PleaseEnterDeposit: 'Пожалуйста, введите сумму депозита',
        isMinRechargeAmtTips: 'Сумма пополнения должна быть больше минимальной суммы пополнения',
        isMaxRechargeAmtTips: 'Сумма пополнения должна быть меньше максимальной суммы пополнения',
        showBonusTips: 'Не участвовать в акциях по депозитам',
        rewardPercentageTxt1_1: 'Более',
        rewardPercentageTxt1_2: 'плюс',
        rewardPercentageTxt1_3: '%',
        rewardPercentageTxt2_1: 'Ежедневный первый депозит ',
        rewardPercentageTxt2_2: '+',
        rewardPercentageTxt2_3: '%',
        rewardPercentageTxt3_1: 'Первый депозит при регистрации ',
        rewardPercentageTxt3_2: '+',
        rewardPercentageTxt3_3: '%',
        Change: 'Изменить',
        DepositBonus: 'Бонус за депозит',
        DepositAmount: 'Сумма депозита',
        Bonus: 'Бонус',
        DepositTips: 'Платформенные депозиты предлагают щедрые вознаграждения, при этом за каждую внесённую сумму денег вы получаете бонус.',
        DepositTips2: 'Используйте T - bank или Сбер для пополнения, другие банки пока не поддерживают.',
        howTitle: 'Как получить бонус за депозит?',
        Step: 'Шаг',
        Step2Title: 'Получить бонус за депозит',
        howTips1: 'Перейдите к депозиту. Выберите предпочитаемый способ депозита для внесения депозита.',
        howTips2: 'После завершения депозита вы получите соответствующий бонус в зависимости от суммы депозита и коэффициента бонуса.',
        TransferDeposit: 'ДЕПОЗИТ USDT',
        OnlineDeposit: 'Онлайн депозит',
        ExchangeRate: 'Курс обмена',
        Tutorial: 'Учебное пособие по пополнению USDT',
        TransferAmount: 'Сумма перевода :',
        TargetAccount: 'Целевые счета :',
        showTips: 'После того, как система обнаружит ваш перевод, он увеличит ваш баланс',
        transferred: 'Я уже перевел деньги.',
        information: 'Передача информации',
        name: 'Имя получателя :',
        bank: 'Банки :'
    },
    DepositDetails: {
        DepositDetails: 'Детали депозита',
        WaitingForPayment: 'Ожидание платежа.',
        countDownTxt1: 'Пожалуйста',
        countDownTxt2: 'завершите депозит',
        ExchangeRate: 'Курс обмена',
        DepositMethod: 'Способ депозита',
        Currency: 'Валюта',
        MainnetProtocol: 'Протокол основной сети (канал сети, очень важно)',
        PaymentAddress: 'Адрес платежа',
        CreationTime: 'Время создания',
        OrderNumber: 'Номер заказа',
        TransactionRemark: 'Примечание к транзакции',
        cashAddress: 'адрес для наличных',
        DepositTips1: '1. Пожалуйста, убедитесь, что правильная сумма после вычета комиссии за вывод (правильная полученная сумма) для завершения транзакции; в противном случае депозит не будет успешным.',
        DepositTips2: '2. Подтвердите, что протокол основной сети, который вы переводите/вносите, соответствует выбранному протоколу основной сети. В противном случае депозит/перевод не будет успешным или будет возвращён.',
        DepositTips3: '3. Поддерживается только USDT. Пожалуйста, не переводите другие валюты на этот адрес.',
        cancelBtn: 'отменить заказ',
        TransferredBtn: 'Я перевёл',
        ContinueBtn: 'Продолжить депозит',
        hashAddress: 'Хэш-адрес',
        pleasetEnterHashAddress: 'пожалуйста, введите хэш-адрес',
        cancelOrderTips: 'Вы хотите отменить этот платёжный заказ?',
        waitPayTips: 'В настоящее время есть неоплаченные заказы, хотите ли вы продолжить оплату?'
    },
    Withdraw: {
        currency: 'Валюта',
        Withdraw: 'Вывод',
        BalanceRecords: 'История баланса',
        chooseAmountTitle: 'Выберите или введите сумму',
        needBonus: 'Мне нужен бонус',
        DepositAmount: 'Сумма депозита',
        Bonus: 'Бонус',
        TotalReceive: 'Итог к получению',
        PAY: 'ОПЛАТИТЬ',
        PaymentProblem: 'Проблемы с оплатой',
        ClickForHelp: 'Нажмите для получения помощи',
        DepositNotes: 'Примечания к депозиту',
        BalanceWithdraw: 'Вывод баланса',
        BonusWithdraw: 'Вывод бонуса',
        ChooseFundsType: 'Выберите тип средств',
        BettingLootRelease: 'Выплата выигрышей по ставкам',
        MinimumWithdrawal: 'Минимальная сумма вывода',
        WithidrawLimitPerday: 'Дневной лимит вывода', // Исправлена опечатка исходного текста: "Withidraw" → "Withdrawal"
        WithdrawTimePerday: 'Дневной период вывода',
        TotalBalance: 'Общий баланс',
        TotalBonus: 'Общий бонус',
        WithdrawableBalance: 'Выводимый баланс',
        WithdrawableBonus: 'Оставшийся бонус',
        WithdrawAmount: 'Сумма вывода',
        All: 'Все',
        ChooseYourBankcard: 'Выберите вашу банковскую карту',
        AddABankCardFirst: 'Сначала добавьте банковскую карту',
        AddBankAccount: 'Добавить банковский счёт',
        WithdrawPassword: 'Пароль для вывода',
        InputWithdrawPassword: 'Введите пароль для вывода',
        Fee: 'Комиссия',
        commission: 'Комиссия',
        Receive: 'Кполучению',
        WithdrawNotes: 'Примечания к выводу',
        WithdrawNotesInfo: 'Примечание: С суммы вывода будет списана комиссия банка в размере 3% + 6 Р. Пожалуйста, внимательно проверьте информацию о выводе. Если вывод не удался или у вас возникли другие вопросы, свяжитесь с службой поддержки 24/7.',
        WithdrawalDetails: 'Детали вывода',
        PleaseEnterDeposit: 'Введите сумму депозита',
        PleaseEnterWithdraw: 'Введите сумму вывода', // Уточнено по контексту (исходный текст абстрактен)
        withdrawalAmountMust10: 'Сумма вывода должна быть кратна 10.',
        PleaseChooseBank: 'Сначала введите информацию о банковской карте',
        PleaseEnterWithdrawPassword: 'Введите пароль для вывода',
        PleaseEnterInteger: 'Введите целое число для суммы вывода',
        PleaseEnterMiniWithdrawPrice: 'Сумма вывода не может быть меньше минимальной суммы вывода', // Исправлена опечатка исходного текста: "Mini" → "Minimum"
        PleaseEnterMaxWithdrawAmt: 'Сумма не может быть больше максимальной.',
        notInTime1: 'Время доступного вывода:',
        notInTime2: 'Время расчетов системы:',
        notInTime3: 'После начала процесса вывода сумма поступит на счет в течение 24 часов. Если возникнут вопросы, свяжитесь с нашей службой поддержки.',
        NotDealWith: 'В обработке',
        withdrawTips: 'Все вознаграждения за рекомендации и комиссии выплачиваются в виде бонуса. Бонус можно вывести напрямую или преобразовать в баланс.', // Исправлены опечатки исходного текста: "comission" → "commission", "bouns" → "bonus"
        ExtraBonus: 'Дополнительный бонус: ',
        ratetxt1: 'Мне нужно еще сделать ставку',
        ratetxt2: 'чтобы вывести деньги',
        ratetxt3: 'все еще нужно сделать ставку в размере ',
        ratetxt4: 'чтобы вывести деньги',
        ratetxt5: 'Incumprimento dos requisitos de retirada.',
        VerifyIdentity: 'Верификация личности',
        ChooseDepositType: 'Выберите тип депозита',
        TransferDeposit: 'Депозит через перевод',
        OnlineDeposit: 'Онлайн-депозит',
        EnterAmount: 'Введите сумму',
        isMinRechargeAmtTips: 'Сумма пополнения должна быть больше минимальной суммы пополнения',
        isMaxRechargeAmtTips: 'Сумма пополнения должна быть меньше максимальной суммы пополнения',
        rewardPercentageTxt1_1: 'Свыше',
        rewardPercentageTxt1_2: 'плюс',
        rewardPercentageTxt1_3: '%',
        rewardPercentageTxt2_1: 'Первый пополнение за день ',
        rewardPercentageTxt2_2: '+',
        rewardPercentageTxt2_3: '%',
        rewardPercentageTxt3_1: 'Первый пополнение после регистрации ',
        rewardPercentageTxt3_2: '+',
        rewardPercentageTxt3_3: '%',
        Illustrate: 'Пояснение',

        Today: 'Сегодня',
        Yesterday: 'Вчера',
        Week: 'Неделя',
        thisWeek: 'Текущая неделя',
        lastWeek: 'Прошедшая неделя',
        Month: 'Месяц',
        thisMonth: 'Текущий месяц',
        lastMonth: 'Прошедший месяц',
        RequestWithdrawal: 'Запросить вывод',
        WithdrawalAmount: 'Сумма вывода',
        BettingRecords: 'История ставок',
        AuditRecords: 'История проверок',
        WithdrawalRecord: 'История выводов',
        BetRecordTips1: 'Вам еще нужно сделать эффективную ставку в размере ',
        BetRecordTips2: 'чтобы вывести деньги!',
        GameName: 'Название игры',
        TotalWithdrawal: 'Общий объем выводов',
        TypeBalance: 'Тип баланса',
        RemainingBalance: 'Оставшийся баланс',

        NoBankTips: 'Пароль для вывода и банковская карта не настроены. Перейдите в настройки.',
        DepositTips: 'Напоминание: Уважаемый клиент! Чтобы средства поступили на ваш счет своевременно, убедитесь, что вы указали реальный и действующий номер счета и имя, а также внимательно проверьте их на корректность. Спасибо!',
        withdrawTips1: 'Условия использования: Уважаемые клиенты, для безопасности ваших средств и своевременного их поступления повторите проверку корректности счета для получения средств.',
        PleaseEnterWithdrawAmt2: 'Введите сумму вывода',
        ManageAccount: 'Управление аккаунтом',
        Add: 'Добавить',
        SetDefault: 'Установить по умолчанию',

        InsertPassword: 'Введите пароль',
        withdrawPwdPopupTips: 'Для безопасности вашего аккаунта введите пароль для вывода.',

        TransferDigital: 'Перевести на цифровую валюту',
        Focus: 'Подписаться', // Контекст интерфейса предполагает функцию "подписки" (не "фокусировки")
        OnlineWithdraw: 'Банковская карта/снятие средств',
        TransferWithdraw: 'USDT/Вывод',
        USDTPaymentAddress: 'Адрес оплаты USDT',
        PleaseEnterUSDTPaymentAddress: 'Введите адрес оплаты USDT',
        WithdrawTips1: 'USDT поступят в течение 10 минут! (Если ваши средства не поступят в течение 10 минут, пожалуйста, наберитесь терпения. Мы обработаем их как можно скорее. Если у вас есть вопросы, пожалуйста, свяжитесь с нашей службой поддержки.).',
        WithdrawTips2: 'Советы по выводу средств: для вывода на банковскую карту требуется минимум ',
        WithdrawTips3: ', а для вывода в USDT — минимум ',
        WithdrawTips4: '. При выводе на банковскую карту средства поступят в течение 24 часов! Вывод в USDT осуществляется в течение 10 минут!',
        disabledWithdraw: 'Функция вывода средств с текущего счёта отключена. Пожалуйста, свяжитесь со службой поддержки!'
    },
    bankset: {
        BankCardDetails: 'Детали банковской карты',
        Type: 'Тип',
        AccountName: 'Название счета',
        NameOfTheAccountHolder: 'Имя держателя счета',
        PIXAccount: 'Счет PIX', // PIX — бразильская система мгновенных платежей, сокращение сохраняется
        InputPIXAccount: 'Введите счет PIX',
        CPFAccount: 'Счет CPF', // CPF — бразильский идентификационный номер физического лица, сокращение сохраняется
        PleaseEnterCPF: 'Пожалуйста, введите CPF',
        WithdrawPassword: 'Пароль для вывода',
        InputWithdrawalPassword: 'Введите пароль для вывода',
        ConfirmWithdrawalPassword: 'Подтвердите пароль для вывода',
        PleaseEnterWithdrawPassword: 'Пожалуйста, введите пароль для вывода',
        InputConfirmWithdrawalPassword: 'Введите пароль для вывода повторно (для подтверждения)',
        ChooseCertificateType: 'Выберите тип документа удостоверения личности',
        InputAccountName: 'Введите название счета',
        InputInconsistentWithdrawPassword: 'Пароли для вывода не совпадают',
        PayeeAccount: 'Номер счета получателя',
        BankName: 'Название банка',
        bankCardNumber: 'Номер банковской карты',
        TaxID: 'ИНН',
        PleaseEnterTaxID: 'Пожалуйста, введите ИНН',
        TaxIDTips: 'Введите 12 - битный или 13 - битный код.',
        ChooseBank: 'Выберите банк',
        PleaseSelectBank: 'Пожалуйста, выберите банк',
        AccountPhone: 'Номер телефона, привязанный к счету',
        EnterPhoneNumber: 'Введите номер телефона',
        PleaseEnterPhoneNumber: 'Пожалуйста, введите ваш номер телефона',
        email: 'Эл. почта',
        PleaseEnterEmail: 'Пожалуйста, введите ваш адрес электронной почты',
        EmailFormat: 'Неправильный формат электронной почты',
        InputPayeeAccount: 'Пожалуйста, введите номер счета получателя',
        PleaseSelectChannelName: 'Пожалуйста, выберите название канала',
        Save: 'Сохранить',
        PayeeAccountTips1: 'Пожалуйста, введите номер телефона из 10 цифр',
        PayeeAccountTips2: 'Пожалуйста, введите номер банковской карты из 16 цифр',
        PayeeAccountTips3: 'Пожалуйста, введите номер банковской карты из 18 цифр',
        WithdrawTips: 'Пожалуйста, введите номер телефона, привязанный к T-bank, для вывода средств. В настоящее время другие банки не поддерживаются.',
        PIXAccountCNPJ: '11 цифр, формат ***.***.***-**', // CNPJ — бразильский идентификационный номер юридического лица, сокращение сохраняется
        ConfirmPIXAccount: 'Подтвердите счет PIX',
        NamePayee: 'Имя получателя',
        phoneNumber: 'Номер мобильного телефона',
        VerificationCode: 'Код подтверждения',
        InputPIXAccountAgain: 'Введите счет PIX повторно',
        InputBankIFSC: 'Введите IFSC банка', // IFSC — код банка в Индии, сокращение сохраняется (в России аналог отсутствует)
        InputNamePayee: 'Введите имя получателя',
        InputVerificationCode: 'Введите код подтверждения',
        CPFAccountCNPJ: 'Введите код компании',
        ConfirmCPFAccount: 'Подтвердите счет CPF',
        Tips: 'Совет: Нужно изменить данные? Свяжитесь с службой поддержки',

        AccountType: 'Тип счета',
        PleaseSelectAccountType: 'Пожалуйста, выберите тип счета',
        ChannelName: 'Название канала',
        IDCard: 'Документ удостоверения личности', // В России стандартным документом является паспорт, но термин универсален
        PleaseEnterIDCardNo: 'Пожалуйста, введите номер документа удостоверения личности',
        IDCardNo13Int: 'Номер документа удостоверения личности должен состоять из 13 цифр (только цифры)',
        Payee10Int: 'Номер счета получателя должен быть из 10 цифр (только цифры) и начинаться с цифры 3',

        linkBankTips: 'Счет не привязан к банковской карте. Пожалуйста, перейдите для привязки.',
        PhoneFormatPeru: 'Номер телефона должен состоять из 9 цифр (только цифры)',

        InterbankAccountCode: 'Межбанковский код счета',
        PleaseEnterInterbankAccountCode: 'Пожалуйста, введите межбанковский код счета',

        IdentityType: 'Тип удостоверения личности',
        PleaseSelectIdentityType: 'Пожалуйста, выберите тип удостоверения личности',

        IDNumber: 'Номер документа удостоверения личности',
        PleaseEnterIDNumber: 'Пожалуйста, введите ваш номер документа удостоверения личности',
        WithdrawalAccount: 'Счет для вывода средств',

        banksetPopupTips1: 'Можно добавлять только счета PIX типа pix-CPF;',
        banksetPopupTips2: 'Проверьте данные внимательно, иначе средства не будут зачислены.',
        banksetPopupTips3: 'Подтвердите имя и номер карты, чтобы гарантировать зачисление средств.',
        PhoneFormatBrazil: 'Номер мобильного телефона из 8 до 14 цифр',
        WrongWithdrawalPassword: 'Неправильный пароль для вывода',
        PleaseEnterIDCardName: 'Укажите настоящее имя, чтобы облегчить будущие выводы средств!',
        DebitCard: 'Дебетовая карта'
    },
    withdrawPwd: {
        title: 'Пароль для вывода',
        withdrawPwdTips1: 'Для обеспечения безопасности ваших средств сначала необходимо установить пароль для вывода!',
        withdrawPwdTips2: 'Установите пароль для вывода',
        withdrawPwdLabel1: 'Новый пароль для вывода',
        withdrawPwdLabel2: 'Подтвердите пароль для вывода',
        withdrawPwdTips3: 'Внимание: Пароль для вывода играет важную роль в защите ваших средств. Сохраните его в тайне, чтобы избежать финансовых потерь.',
        notContinuousNumbers: 'Не может состоять из 6 одинаковых или последовательных цифр',
        PleaseEnterWithdrawalPassword: 'Пожалуйста, введите пароль для вывода',
        ConfirmWithdrawalPassword: 'Подтвердите пароль для вывода',
        InputInconsistentWithdrawPassword: 'Пароли для вывода не совпадают'
    },
    Notification: {
        Notification: 'Уведомление',
        news: 'Новости',
        nomore: 'Больше нет'
    },
    bonusCenter: {
        BonusDetails: 'Детали бонуса',
        BonusCategories: 'Категории бонусов',
        WeeklyBonus: 'Еженедельный бонус',
        MonthlyBonus: 'Ежемесячный бонус',
        LevelupBonus: 'Бонус за повышение уровня',
        BonusRain: 'Красный конверт',
        DepositBonus: 'Бонус за депозит',
        SpecialBonus: 'Специальный бонус',
        BonusTransactions: 'Транзакции бонусов',
        BonusType: 'Тип бонуса',
        ClaimedAmount: 'Полученная сумма',
        Time: 'Время',
        OopsNodatayet: 'Упс! Данных пока нет!',
        TotalBonusClaime: 'Общая сумма полученных бонусов',
        TotalGeneralBonus: 'Активный бонус',
        TotalVIPBonus: 'Общий VIP бонус',
        rechargeBonus: 'Бонус за пополнение',
        Details: 'Детали',
        TotalBonus: 'Общий бонус:',
        Rules: 'Правила',
        Bonusends: 'Бонус заканчивается:',
        DepositNow: 'Пополнить сейчас',
        Generalbonus: 'Обычный бонус',
        Todayevents: 'События сегодня',
        Nextrain: 'Следующий раз',
        CheckIn: 'Зарегистрироваться',
        Counts: 'Количество',
        Deposit: 'Депозит',
        VIPBonus: 'VIP бонус',
        Levelupbonus: 'Бонус за повышение уровня',
        XPtoVIP: 'XP до VIP',
        UpgradeBonus: 'Бонус за повышение',
        NextLevelBonus: 'Бонус следующего уровня',
        ViewVIPClub: 'Посмотреть VIP клуб',
        Wager: 'Ставка',
        VIP: 'VIP',
        Unlockendless: 'Разблокируйте бесконечные преимущества',
        Generousbonuses: 'Щедрые бонусы готовы! Присоединяйтесь к нам. Найдите свои сокровища.',
        JoinNow: 'Присоединяйтесь сейчас',
        Upgradebonuses: 'Обновите VIP, чтобы получить бонусы',
        Invitefriendss: 'Пригласите друзей играть в игры и получите бонусы',
        Completequest: 'Завершите задание, чтобы получить бонусы',
        Winbigwith: 'Выигрывайте крупно с нашими еженедельными и ежемесячными бонусами!',
        Discover: 'Откройте для себя необычные бонусы',
        numerousbonuses: 'Мы предлагаем множество бонусов каждому пользователю. Новые награды каждый день и каждую неделю.',
        Signbonus: 'Зарегистрируйтесь и получите бонус',
        LevelupVIP: 'Повышение уровня VIP, больше наград!',
        VIPstatusmeans: 'Статус VIP означает больше ценности здесь. Вы можете быстро накапливать богатство и создавать прочную финансовую базу, разблокировав его преимущества.',
        Whatget: 'Что получают VIP?',
        Saygoodbye: 'Скажите прощай обычным играм, привет чистой роскоши.',
        RedeemBonusCode: 'ПРИМЕНИТЬ',
        RedeemCode: 'Погасить код',
        AllBonuses: 'Все бонусы',
        eventManage: 'Активный бонус',
        VIPCycleReward: 'Награда за уровень VIP',
        Extend: 'Промо-бонус',
        reliefMoneyEvent: 'Акция по спасению золота',
        singInEvent: 'Акция по регистрации',
        luckyWheelEvent: 'Акция с удачным колесом',
        redPacletEvent: 'Акция с красным конвертом',
        gameBettingEvent: 'Акция по ставкам на игры',
        pinduoduoEvent: 'Пригласительные акции',
        rankingListEvent: 'Рейтинг',
        registerRewardsEvent: 'Акция по регистрации',
        VIPWeeklyReward: 'Еженедельные награды VIP',
        VIPMonthlyReward: 'Ежемесячные награды VIP',
        VIPLevelUpReward: 'Награда за повышение уровня VIP',
        Redeemyour: 'Погасите свой бонусный код ниже.',
        Redeem: 'Погасить',
        Unlocked: 'Разблокировано',
        RechargeAmount: 'Сумма пополнения',
        RegisterAndObtain: 'Зарегистрируйтесь сейчас и получите:',
        bonus: 'бонус',
        FreeSpins: ' бесплатных вращений',
        depositBonusTips: ' – онлайн-казино с мгновенными выводами, где ваши любимые стримеры также проводят прямые трансляции.',
        GetBonus: 'Получить бонус',
        depositBonusTips2: 'Зарегистрируйся и открой доступ к бонусам',
        depositBonusTips3: 'Каждый раз при пополнении баланса, ты получаешь бонусы на общую сумму ',
        depositBonusTips4: '%, если учитывать все ',
        depositBonusTips5: ' депозита.',
        depositBonusTips6: '(Игра с бесплатными вращениями: Big Bass Christmas Bash)',
        thDeposit: 'й депозит'
    },
    lossSupport: {
        title: 'КЕШБЕК/CASHBACK',
        lossSupport: 'Поддержка',
        yesterdayLoss: 'Потери вчера',
        todayBonus: 'Бонус поддержки сегодня',
        loseMoney: 'СУММА',
        extraprizes: '% CASHBACK',
        amountDamage: 'СУММА',
        AmountReward: 'CASHBACK',
        EventIntro: 'Инструкции по событию:',
        VIPLevel: 'Класс VIP'
    },
    rebate: {
        title: 'Возврат ставок',
        BettingVolume: 'Объём ставок',
        RewardAmount: 'Сумма вознаграждения',
        EventIntro: 'Инструкции по событию:'
    },
    downApp: {
        downAppSuccTips: 'Вы успешно установили приложение.',
        downAppSuccTips2: 'Вы уже установили приложение. Или нажмите на значок кнопки загрузки в правом верхнем углу адреса браузера, чтобы переустановить.',
        SaveVersionDesktop: 'Сохранить веб-версию на рабочем столе',
        SaveVersionTips: 'Нажмите, чтобы быстро загрузить приложение на рабочий стол',
        QuickVersion: 'Быстрая версия',
        NormalVersion: 'Обычная версия',
        download: 'Скачать',
        NotInDevice: 'Не совместимо с этим устройством',
        Games: 'Игры',
        Apps: 'Приложения',
        Movies: 'Фильмы',
        Books: 'Книги',
        Kids: 'Дети',
        ProductMadness: 'Безумие продуктов',
        InAppPurchases: 'Покупки в приложении',
        reviews: 'отзывы',
        Downloads: 'Загрузки',
        Install: 'Установить',
        Share: 'Поделиться',
        AddToWishlist: 'Добавить в список желаемого',
        appAvailableDevice: 'Это приложение доступно для вашего устройства',
        AboutGame: 'Об этой игре',
        comment1: 'Испытайте азарт карт и волнение высоких ставок в gd-goatbet! Присоединяйтесь к яркому сообществу любителей карт в этой погружающей и социальной карточной игре. Играйте в Teen Patti в различных режимах, участвуйте в захватывающих турнирах и станьте величайшим gd-goatbet. С его аутентичным игровым процессом, социальными функциями и соревновательным духом, gd-goatbet предлагает захватывающий опыт игры в карты, который заставит вас возвращаться снова и снова.',
        comment2: '1. Аутентичный опыт Teen Patti: Погрузитесь в аутентичную и традиционную карточную игру Teen Patti, с реалистичными правилами и увлекательным игровым процессом.',
        comment3: '2. Разнообразные игровые режимы: Исследуйте различные игровые режимы, от классического Teen Patti до инновационных вариаций, предлагая динамичный и развлекательный игровой опыт.',
        comment4: '3. Социальные карточные игры: Связывайтесь с друзьями, присоединяйтесь к клубам и участвуйте в многопользовательских матчах, способствуя социальному и интерактивному игровому окружению.',
        DataSafety: 'Безопасность данных',
        comment5: 'Безопасность начинается с понимания того, как разработчики собирают и делятся вашими данными. Практики конфиденциальности и безопасности данных могут различаться в зависимости от вашего использования, региона и возраста. Разработчик предоставил эту информацию и может обновлять её со временем.',
        comment6: 'Это приложение может делиться этими типами данных с третьими сторонами',
        comment7: 'Местоположение, Личная информация и 6 других',
        comment8: 'Это приложение может собирать эти типы данных',
        comment9: 'Местоположение, Личная информация и 6',
        comment10: 'Данные шифруются в пути',
        comment11: 'Вы можете запросить удаление данных',
        SeeDetails: 'Смотрите детали',
        RatingsAndReviews: 'Рейтинги и отзывы',
        Phone: 'Телефон',
        Tablet: 'Планшет',
        October: 'Октябрь',
        comment12: 'Отличный выбор популярных игр, которые также есть в казино, и много удовольствия от игры! Просмотр рекламы может поддерживать игру, но иногда это может быть мучительно медленно. Будьте готовы делать покупки или иметь много терпения. Иногда вам нужно смотреть рекламу от 30 секунд до минуты между несколькими раздачами, и это может продолжаться несколько раздач. В некоторых играх вы не можете выполнить требования бонуса, если не купите деньги для игры. ВСЕ-TAK, это моя любимая из всех казино-приложений!',
        comment13: '3,394 человека нашли этот отзыв полезным',
        comment14: 'Вы нашли это полезным?',
        Yes: 'Да',
        No: 'Нет',
        September: 'Сентябрь',
        comment15: 'Мне действительно нравится эта игра. У неё есть разнообразие различных слотов для игры. Я могу зарабатывать дополнительные монеты по мере игры. Не так много рекламы для просмотра. Сумма монет при покупке ниже, чем в других играх, но из-за качества этой игры они стоят того, на мой взгляд. Я скачал и затем удалил другие приложения после их использования.',
        comment16: '1,110 человек нашли этот отзыв полезным',
        comment17: 'Вы нашли это полезным?',
        WhatNew: 'Что нового',
        comment18: 'Получите наши НОВЫЕ игры в нашем последнем обновлении!',
        comment19: 'Для лучшего опыта и самого БОЛЬШОГО УДОВОЛЬСТВИЯ мы исправили ошибки и оптимизировали вашу игру.',
        AppSupport: 'Поддержка приложения',
        SimilarGames: 'Похожие игры',
        LightningLinkCasinoSlots: 'Слоты казино Lightning Link',
        QuickHitCasinoSlotGames: 'Слоты казино Quick Hit',
        SciPlay: 'SciPlay',
        LuckyTimeSlots: 'Слоты Lucky Time',
        DGNGames: 'DGN Games',
        CashTornadoSlotsCasino: 'Слоты Cash Tornado™ - Казино',
        ZerooGravityGames: 'Игры Zeroo Gravity',
        GoldFishCasinoSlot: 'Слот Gold Fish Casino',
        FlagInappropriate: 'Отметить как неподобающее',
        GooglePlay: 'Играть',
        PlayPass: 'Играть',
        PlayPoints: 'Игровые очки',
        GiftCards: 'Подарочные карты',
        Redeem: 'Погасить',
        RefundPolicy: 'Политика возврата',
        KidsFamily: 'Дети и семья',
        ParentGuide: 'Руководство для родителей',
        FamilySharing: 'Семейный доступ',
        TermsService: 'Условия обслуживания',
        Privacidade: 'Конфиденциальность',
        SobreGooglePlay: 'О Play',
        Desenvolvedores: 'Разработчики',
        GoogleStore: 'Магазин',
        UnitedStates: 'Соединённые Штаты (английский)',

        AppStore: 'App Store',
        DesignedIPhone: 'Разработано для iPhone',
        get: 'получить',
        iPhoneScreenshots: 'Скриншоты iPhone',
        AppPrivacy: 'Конфиденциальность приложения',
        intro1: 'Разработчик, ',
        intro2: ', указал, что практики конфиденциальности приложения могут включать обработку данных, как описано ниже. Для получения дополнительной информации смотрите ',
        intro3: 'политику конфиденциальности разработчика',
        intro4: 'Данные не собираются',
        intro5: 'Разработчик не собирает никаких данных из этого приложения.',
        intro6: 'Практики конфиденциальности могут различаться, например, в зависимости от функций, которые вы используете, или вашего возраста.',
        intro7: 'Информация',
        Seller: 'Продавец',
        Size: 'Размер',
        Category: 'Категория',
        Compatibility: 'Совместимость',
        iPhone: 'iPhone',
        support1: 'Требуется iOS 10.0 или новее.',
        iPodTouch: 'iPod touch',
        support2: 'Требуется iOS 10.0 или новее.',
        Mac: 'Mac',
        support3: 'Требуется macOS 11.0 или новее и Mac с чипом Apple M1 или новее.',
        Languages: 'Языки',
        EnglishSimplifiedChinese: 'Английский, Упрощённый китайский',
        AgeRating: 'Возрастной рейтинг',
        UnrestrictedWebAccess: 'Неограниченный доступ в интернет',
        InfrequentMildHorrorFearThemes: 'Редкие/умеренные темы ужаса/страха',
        Copyright: 'Авторское право',
        Price: 'Цена',
        Free: 'Бесплатно',
        PrivacyPolicy: 'Политика конфиденциальности',
        Supports: 'Поддержка',
        GameCenter: 'Центр игр',
        GameCenterTips: 'Соревнуйтесь с друзьями и проверяйте таблицы лидеров и достижения.',
        Morewaysshop: 'Больше способов покупки',
        FindAppleStore: 'Найдите магазин Apple',
        or: 'или',
        otherRetailer: 'другой ритейлер',
        nearYou: 'рядом с вами.',
        OrCall: 'Или позвоните по номеру 1-800-MY-APPLE.',
        ChooseYourCountryRegion: 'Выберите вашу страну или регион',
        TermsUse: 'Условия использования',
        SalesRefunds: 'Продажа и возврат',
        Legal: 'Юридическая информация',
        SiteMap: 'Карта сайта',
        ClickButtonToDownload: 'Скачайте приложение для более безопасных выводов',
        ClickButtonToDownload2: 'Скачайте приложение, чтобы играть в игры',
        ApplicableWindows: 'Применимо к окнам',
        ApplicableWindowsTips: 'Добавить быстрый доступ к рабочей области'
    },
    event: {
        Detail: 'Детали',
        greatBonus: 'Отличный бонус за ',
        everyDeposit: 'Каждый депозит',
        firstDeposit: 'Первый депозит',
        secondDeposit: 'Второй депозит',
        thirdDeposit: 'Третий депозит',
        upTo: 'До',
        allPlayers: 'Доступно для всех игроков ',
        before: 'Перед',
        Bonus: 'Бонус',
        Deposit: 'Депозит',
        Recompensas: 'Special rewards',
        preparado: 'Weve prepared many bonuses for you, so dont miss out! Come and claim them!',
        RewardReceived: 'Награда получена',
        redPacketBtnsName: 'Открыто в назначенное время'
    },
    person: {
        Bets: 'Ставки',
        Balance: 'Баланс',
        Bonus: 'Бонус',
        Transaction: 'Транзакция',
        History: 'История',
        Welcome: 'Добро пожаловать в ',
        signIn: 'Пожалуйста, сначала зарегистрируйтесь или войдите',
        invite: 'Пригласить друзей',
        redPacket: 'Красный конверт',
        Notification: 'Уведомление',
        Promotion: 'БОНУСЫ',
        VIPClub: 'VIP клуб',
        LiveChat: 'Живой чат',
        AccountSettings: 'Настройки аккаунта',
        Install: 'Установить',
        BonusTransfer: 'Перевод премий',
        transferMsg: 'Бонусов недостаточно.',
        transferTips1: 'Вы хотите перевести ',
        transferTips2: ' долларов в остаток?',
        transferTips3: 'Немедленный перевод',
        InvitationCenter: 'Реферальная программа',
        PersonalCenter: 'Персональный центр',
        VIPNeed: 'Требования для повышения до VIP',
        AccountTotal: 'Итог по счёту'
    },
    Vip: {
        VIPSupport: 'Поддержка VIP',
        LevelBenefits: 'Уровень VIP и преимущества',
        Deposits: 'Депозиты',
        Bets: 'Ставки',
        or: 'или',
        to: 'к',
        joinClub: 'Присоединяйтесь к VIP клубу. Разблокируйте высокие кэшбэки. Все виды изысканных подарков. Это вас удивит!',
        levelUp: 'Повышение уровня VIP',
        Steps: 'Шаги',
        Benefits: 'Преимущества',
        benefits1: 'Бонус за повышение уровня',
        benefits2: 'Еженедельный бонус',
        benefits3: 'Ежемесячный бонус',
        info1: 'Повышение уровня VIP для получения бонуса!',
        info2: 'Получайте бесплатный бонус каждую неделю.',
        info3: 'Получайте бесплатный бонус каждый месяц.',
        More: 'Больше',
        promotionTip: 'Пожалуйста, смотрите наши акции для получения дополнительной информации.',
        Promotions: 'Акции',
        FAQ: 'Часто задаваемые вопросы',
        question1: '1. Что такое "Бонус за повышение уровня"?',
        answer1: ' "Бонус за повышение уровня" - это привилегия VIP, где вознаграждения увеличиваются по мере продвижения к более высоким уровням VIP.',
        question2: '2. Преимущества повышения уровня VIP',
        answer2: 'Повышение уровня VIP может дать более высокую сумму вывода и более низкую комиссию за вывод!',
        LevelUpBonus: 'Бонус за повышение уровня',
        WeeklyBonus: 'Еженедельный бонус',
        MonthlyBonus: 'Ежемесячный бонус',
        Level: 'Уровень',
        RequiredDeposit: 'Требуемый депозит',
        RequiredBet: 'Требуемая ставка',
        Get: 'Получить',
        UpgradeBonus: 'Бонус за повышение',
        vipRewards: 'Зарегистрируйтесь и получите эксклюзивные награды VIP!',
        earnPoints: 'Делайте ставки и зарабатывайте очки!',
        levelUpBenifits: 'Разблокируйте награды, повышайте свои преимущества!',
        Step1: 'Шаг1',
        Step2: 'Шаг2',
        Step3: 'Шаг3',
        LevelReward: 'Награда за уровень',
        UpgradeYourVIPLevelReceiveRewards: 'Повысьте свой VIP-уровень, чтобы получить награды.',
        TotalCheckInRewards: 'Общая сумма наград за вход',
        WeeklySalary: 'Еженедельная выплата',
        DistributedAutomaticallyEveryWednesday: 'Распределяется автоматически каждую среду.',
        LossSubsidy: 'Субсидия на убытки',
        DistributedAutomaticallyEveryMonday: 'Распределяется автоматически каждый понедельник.',
        Withdraw: 'Вывести',
        MaximumSingleWithdrawalLimit: 'Максимальный лимит единовременного вывода',
        NumberWithdrawalsPerDay: 'Количество выводов в день',
        CheckIn: 'Регистрация',
        KeepYourVipLevel: 'Сохраняйте свой VIP-уровень!',
        KeepVipLevelDescription: 'Играйте каждый месяц, чтобы сохранить свой VIP-уровень и избежать понижения.',
        KeepVipLevelDuring: 'Сохраняйте VIP-уровень в период',
        RechargeAmount: 'Сумма пополнения',
        BetAmount: 'Сумма ставок'
    },
    MyProfile: {
        Profile: 'Профиль',
        ID: 'ID',
        Join: 'Присоединиться',
        TotalBet: 'Общая ставка',
        TotalBonus: 'Общий бонус',
        FavoriteGames: 'Избранные игры'
    },
    Transaction: {
        Transaction: 'Транзакция',
        TotalAmount: 'Общая сумма',
        DepositValue: 'Сумма депозита',
        Bonus: 'Бонус',
        Received: 'Получено',
        WithdrawBonus: 'Вывод бонуса',
        Rate: 'комиссия',
        Today: 'Сегодня',
        Yesterday: 'Вчера',
        LastThreeDays: 'Последние 3 дня',
        LastSevenDays: 'Последние 7 дней',
        LastFifteenDays: 'Последние 15 дней',
        LastThiryDays: 'Последние 30 дней',
        AllState: 'Все состояния',
        Processing: 'Обработка',
        Successful: 'Успешно',
        Failed: 'Неудачно',
        WithdrawFail: 'Неудача при выводе',
        Withdrawing: 'Вывод средств',
        WithdrawSuccess: 'Вывод средств успешен',
        PaySuccess: 'Оплата успешна',
        Paying: 'Оплата',
        Fail: 'Неудача',
        WaitPay: 'Ожидание оплаты',
        Cancel: 'Отмена'
    },
    BetsHistory: {
        BetsHistory: 'История ставок'
    },
    Setting: {
        Setting: 'Настройки',
        oldPasswordLabel: 'Текущий пароль',
        newPasswordLabel: 'Новый пароль',
        confirmPasswordLabel: 'Подтвердите новый пароль',
        LiveChat: 'Живой чат',
        AccountID: 'ID аккаунта',
        PhoneNumber: 'Номер телефона',
        Password: 'Пароль',
        Change: 'Изменить',
        oldPasswordTips: 'введите оригинальный пароль',
        PleaseEnterYourOriginalPassword: 'Пожалуйста, введите ваш оригинальный пароль',
        passwordTips: 'Пароль (6-16)',
        PleaseEnterYourNewPassword: 'Пожалуйста, введите ваш новый пароль',
        passwordTips2: 'Введите пароль еще раз',
        PleaseEnterYourNewPasswordSure: 'Пожалуйста, введите ваш новый пароль еще раз',
        changePwd: 'Сменить пароль'
    },
    RedPacket: {
        RedPacket: 'Красный пакет',
        NextEvent: 'Следующее событие',
        Participate: 'Участвовать'
    },
    turntable: {
        Roulette: 'Рулетка',
        lottery: 'Лотерея',
        title: 'Колесо удачи',
        totalTips1: 'Текущие счастливые очки ',
        totalTips2: 'Вам еще нужно сделать ставку ',
        totalTips3: ' чтобы получить ',
        totalTips4: ' Счастливые очки',
        totalTips5: 'Первая зарядка в день дает ',
        totalTips6: ' счастливых значений.',
        totalTips7: 'Одна зарядка ',
        totalTips8: ' или более, вы можете получить 1 лотерею, неограниченное количество раз',
        totalTips9: 'Заработанную сумму можно снять, когда она превысит ',
        totalTips10: 'Закончились ли твои бесплатные вращения? Пригласи друзей зарегистрироваться и получи дополнительные вращения.',
        totalTips11: 'Ты можешь выиграть до ',
        totalTips12: ' в призах!',
        totalTips13: 'Добро пожаловать на колесо фортуны!',
        totalTips14: 'Получите ваш щедрый бонус!',
        totalTips15: 'Вы завершили ',
        totalTips16: ', вам осталось всего ',
        totalTips17: ' в премиях, чтобы снять свои деньги.',
        totalTips18: 'Пригласить друзей выполнить задания.',
        Silver: 'Серебро',
        Gold: 'Золото',
        Diamond: 'Алмаз',
        tab1: 'Отчет',
        tab2: 'Моя ссылка',
        JustRemoved: 'только что убрано',
        drawTitle1: 'Поздравляем',
        drawTitle2: 'к сожалению',
        drawContent1: 'получить',
        drawContent2: 'Награда не получена',
        cashOut: 'Вывод средств',
        InviteFriends: 'Пригласите друзей, чтобы получить деньги',
        nextFreeSpin: 'Следующий бесплатный спин:',
        targetAmount: 'Целевая сумма:',
        withdrawSuccessfully: 'Вывод успешен',
        downTimeTips1: 'Через',
        downTimeTips2: 'секунд,',
        downTimeTips3: 'накопленные бонусы и лотерейные разы будут очищены',
        drawNumbers: 'Количество розыгрышей',
        winPopupTitle: 'Поздравляем! Вы выиграли:',
        winPopupWithdrawTip: 'Вы сможете начать вывод, когда накопленная сумма достигнет',
        winPopupButton: 'Посмотреть задания',
        winPopupHint: 'Выполняйте миссии, чтобы получать бесплатные вращения',
        sharePopupTitle: 'Пригласите друзей, чтобы помочь с выводом',
        sharePopupRewardLabel: 'Полученная сумма награды',
        sharePopupNeedText1: 'Вам еще нужно',
        sharePopupNeedText2: 'для вывода средств',
        sharePopupTaskTip: 'Выполнение следующих заданий поможет вам вывести деньги быстрее:',
        sharePopupInviteTip1: 'Пригласите 1 активного игрока и получите',
        sharePopupInviteTip2: 'бесплатный спин'
    },
    winRankList: {
        RankingList: 'Рейтинг',
        Ranking: 'Рейтинг',
        Rules: 'Правила',
        MyRewards: 'Мои награды',
        ActivityAward: 'Награда за активность:',
        Rank: 'Ранг',
        Daily: 'Ежедневно',
        Weekly: 'Еженедельно',
        Monthly: 'Ежемесячно',
        WeeklyList: 'Еженедельный список',
        MonthlyList: 'Ежемесячный список',
        TotalBets: 'Общие ставки',
        Reward: 'Награда:',
        NoRank: 'Нет ранга',
        MyBets: 'Мои ставки',
        RanksLeft: 'Осталось рангов',
        MyReward: 'Моя награда',
        History: 'История',
        LastDay: 'Последний день',
        LastWeek: 'Последняя неделя',
        LastMonth: 'Последний месяц',
        Rewards: 'Награды',
        PhoneNo: 'Телефон'
    },
    footer: {
        Promo: 'Промо',
        VIPClub: 'VIP клуб',
        Promotions: 'Акции',
        ReferAndEarn: 'Пригласите и зарабатывайте',
        Bonus: 'Бонус',
        AboutUs: 'О нас',
        About: 'О',
        DataProtectionPolicy: 'Политика защиты данных',
        BusinessContinuityPolicy: 'Политика непрерывности бизнеса',
        Help: 'Помощь',
        PrivacyPolicy: 'Политика конфиденциальности',
        ServiceTerms: 'Условия обслуживания',
        GamblingAddictionWarnings: 'Предупреждения о зависимости от азартных игр',
        GamblingTreatmentCenters: 'Центры лечения азартных игр',
        ResponsibleGambling: 'Ответственная игра',
        ContactUs: 'Связаться с нами',
        JoinOurGroup: 'Присоединяйтесь к нашей группе',
        ContactViaTelegram: 'Связаться через Telegram',
        OnlineServer: 'Онлайн-сервер',
        JoinourCommunity: 'Присоединяйтесь к нашему сообществу',
        tips1: '1. Этот продукт предназначен для пользователей старше 18 лет и предназначен только для развлекательных целей.',
        tips2: '2. Эта игра содержит покупки внутри приложения.',
        tips3: '3. То, что игрок играет или выигрывает в социальной азартной игре, не означает, что он выиграет на ставках на реальные деньги и связанных играх в будущем.',
        socialMedia: 'Социальные медиа',
        ApplicableTo: 'подходит для'
    },
    joinChannel: {
        socialTitle: 'Социальные сети',
        communityIntro: 'Присоединяйтесь к нашему сообществу, чтобы узнавать новости, акции и всё лучшее от {projectName}.',
        telegramDescription: 'Новости, акции и обновления в реальном времени.',
        instagramDescription: 'Наши последние новости и эксклюзивные материалы.',
        whatsappDescription: 'Акции и важные сообщения.',
        navTitle: 'Interesting activities',
        mobileTitle: 'Join the community',
        mobileSubtitle: 'Plenty of rewards delivered on time',
        desktopTitle: 'Joining our official channels brings many benefits.',
        desktopSubtitle: '{domainName} warmly invites you to join our Instagram, WhatsApp, and Telegram channels for smoother communication.',
        instagramBtn: 'Join Instagram',
        telegramBtn: 'Join Telegram',
        whatsappBtn: 'Join WhatsApp',
        infoIntro: 'We will announce the following activities and related information in our Telegram and WhatsApp channels:',
        info1: 'We will announce new platform activities on our Instagram, Telegram, and WhatsApp channels as soon as possible.',
        info2: 'We will regularly update platform rewards on our Instagram, Telegram, and WhatsApp channels.',
        info3: 'We will share {domainName} official bonus rewards every day.',
        info4: 'We will announce the platform winner list on our Instagram, Telegram, and WhatsApp channels as soon as possible.',
        info5: 'We will announce platform changes and maintenance on our Instagram, Telegram, and WhatsApp channels as soon as possible.',
        info6: 'We will announce referral reward system updates on our Instagram, Telegram, and WhatsApp channels as soon as possible.',
        info7: 'Any issue related to deposits and withdrawals will be announced on our Instagram, Telegram, and WhatsApp channels as soon as possible.',
        info8: 'Any game maintenance on the platform will be announced on our Instagram, Telegram, and WhatsApp channels as soon as possible.'
    },
    treasureChest: {
        treasureChest: 'Сундук с сокровищами',
        title: 'ПРИГЛАШАЙТЕ ДРУЗЕЙ, ЧТОБЫ ОТКРЫТЬ СУНДУК С СОКРОВИЩАМИ',
        save: 'Нажмите, чтобы сохранить',
        ReferralLink: 'Реферальная ссылка',
        directSubordinates: 'Прямые подчиненные',
        ReferralCode: 'Реферальный код',
        chestInfoTips1: 'ЧТО ТАКОЙ АКТИВНЫЙ РЕФЕРАЛ? (СООТВЕТСТВУЕТ ВСЕМ ТРЕБОВАНИЯМ)',
        chestInfoTips2: 'РЕФЕРАЛ СДЕЛАЛ ДЕПОЗИТОВ В ОБЩЕМ НА ',
        chestInfoTips3: '',
        chestInfoTips4: 'РЕФЕРАЛЫ СОВЕРШИЛИ СТАВКИ НА ',
        chestInfoTips5: ' И БОЛЕЕ',
        People: 'РЕФЕРАЛ',
        People2: 'РЕФЕРАЛА',
        People3: 'РЕФЕРАЛОВ',
        commissionAccount: 'Комиссионный аккаунт',
        todayCommittee: 'Комиссия, выпущенная сегодня',
        historyCommittee: 'Опубликованные исторические комиссии',
        obtain: 'получить',
        inviteTitle: 'Получено за приглашение действительных подчиненных',
        highestRebate: 'Максимальный возврат',
        commissionBalance: 'Баланс комиссии',
        totalCommissionIncome: 'Общий доход от комиссии',
        EstimatedCommissionToday: 'Ожидаемая комиссия сегодня',
        YesterdayCommittee: 'Комиссия за вчера',
        register: 'Зарегистрироваться',
        firstChargeMark: 'Знак первого пополнения',
        firstFee: 'Первая плата',
        chargeAmount: 'Сумма пополнения',
        totalHistoricalData: 'Общие исторические данные',
        firstLevelSubordinateData: 'Данные подчиненных первого уровня',
        secondarySubordinateData: 'Данные подчиненных второго уровня',
        thirdLevelSubordinateData: 'Данные подчиненных третьего уровня',
        rewardRatio: 'Коэффициент вознаграждения',
        collectRebates: 'Сбор вознаграждений за пополнение',
        teamCollection: 'Пополнение',
        firstLevelCommission: 'Комиссия первого уровня:',
        secondLevelCommission: 'Комиссия второго уровня:',
        thirdLevelCommission: 'Комиссия третьего уровня:',
        firstLevelBetting: 'Ставки первого уровня:',
        secondLevelBetting: 'Ставки второго уровня:',
        thirdLevelBetting: 'Ставки третьего уровня:',
        claim: 'получить',
        numberTreasureChestsClaimed: 'Количество доступных ящиков',
        noClaimedTips: 'Нет никакого ящика.'
    },
    Pending: {
        Pending: 'В ожидании',
        Hour: 'Час',
        Type: 'Тип',
        Bonus: 'Бонус',
        Limit: 'Лимит',
        EndTime: 'Время окончания',
        All: 'Все',
        DailyAttendance: 'Ежедневное присутствие',
        TimedRedEnvelope: 'Временный красный конверт',
        LuckyTurntable: 'Счастливое колесо',
        ReliefMoney: 'Деньги помощи',
        RegisterRewards: 'Награды за регистрацию',
        Other: 'Другое'
    },
    depositTotal: {
        title: 'Накопленное вознаграждение за пополнение',
        AccumulatedRecharge: 'Совокупное пополнение',
        GetRewards: 'Награды',
        EventIntro: 'Описание деятельности：'
    },
    depositRepeat: {
        full: 'Полное',
        RegisterFirstCharge: 'Регистрация первого залога',
        DailyFirstCharge: 'Первая зарядка в день',
        EachRecharge: 'Каждое пополнение',
        give: 'Подарок',
        thRecharge: ' - е пополнение',
        EveryRecharge: 'Каждое пополнение',
        EventIntro: 'Описание деятельности：'
    },
    scratchCards: {
        title: 'Все скретч-карты',
        prizeUpTo1: 'Призы до',
        prizeUpTo2: 'Приз до',
        pixPayment: 'БЕЗ PIX',
        playNow: 'Играть сейчас',
        price: 'Цена',
        maxPrize: 'Максимальный приз',
        prizeTable: 'Таблица призов',
        playFor: 'Играть за',
        scratchTitle2: 'СКРЕТЧИ, НАЙДИ, ПОБЕДИ',
        winCondition1: 'Найдите 3 одинаковых',
        winCondition2: 'выиграйте сразу',
        scratchAll: 'Скрепч все сразу',
        shaved: 'Скрепчённый',
        youWon: 'Вы выиграли',
        notThisTime: 'Не на этот раз',
        encouragement: 'Но не расстраивайтесь, удача может быть в следующей скретч-карте',
        playAgain: 'Играть снова',
        yourBalance: 'Ваш баланс',
        insufficientBalance: 'Недостаточный баланс',
        scrape: 'СКРЕПЧИ',
        here: 'ЗДЕСЬ',
        playCard: 'Играть в скретч-карту',
        startPlay: 'Начать играть',
        buyToPlay: 'Купить, чтобы играть',
        buyTip1: 'Купите скретч-карту, чтобы начать играть',
        buyTip2: 'Нажмите кнопку ниже, чтобы приобрести',
        buyCard: 'Купить скретч-карту',
        prizeContent: 'СОДЕРЖИМОЕ ЭТОЙ СКРЕТЧ-КАРТЫ',
        congratulation: 'ПОЗДРАВЛЯЕМ',
        addToAccount: 'Сумма будет автоматически добавлена на ваш счет.',
        revealAll: 'Раскрыть все',
        successTip: 'Вы победитель, попробуйте снова',
        failTip: 'Вы не победитель, попробуйте снова'
    },
    RedemptionCode: {
        tips1: 'Зарегистрируйтесь на канале, чтобы получать купоны для обмена каждый день, и деньги будут зачислены напрямую на ваш счет.',
        RedemptionCode: 'Код активации',
        PleaseEnterTheRedemptionCode: 'Введите код активации.',
        PleaseEnterTheRedemptionCode2: 'Пожалуйста, перейдите в канал Telegram и канал WhatsApp, чтобы получить.',
        exchange: 'Обменять приз',
        RedemptionRecord: 'История призов'
    },
    red_envelope: {
        ClaimNow: 'Получить награды',
        homepage: 'домашняя страница',
        getMoney: 'Поздравляем! Вы получили ',
        remainder: 'остаток',
        GrabRedEnvelope: 'Забрать красный конверт'
    },
    depositWithdraw: {
        MyAssets: 'Мои активы',
        TotalBalance: 'Общий баланс',
        WithdrawableAmount: 'Сумма для вывода',
        Recharge: 'Пополнить',
        Retirar: 'Вывести',
        records: 'Записи',
        RechargeAmount: 'Сумма пополнения',
        ExplanationBonusEvent: 'Описание бонусного мероприятия',
        MinimumDeposit: 'Минимальный депозит ',
        RechargeBonusTips: 'Пополните счет на рекомендуемую сумму, чтобы получить соответствующий бонус. Сумма бонуса будет начислена вместе с суммой пополнения.',
        RechargeMethods: 'Способы пополнения',
        DepositeAhora: 'Пополнить сейчас',

        MinimumWithdrawal: 'Минимальный вывод ',
        ConfirmWithdrawal: 'Подтвердить вывод',

        RechargeRecords: 'История пополнений',
        WithdrawalRecords: 'История выводов',
        rechargeTaskTip1: 'Только пополнив',
        rechargeTaskTip2: 'вы сможете выполнить задачу'
    },
    playGameByDeposit: {
        title: 'Пополните счет, чтобы разблокировать игры',
        desc: 'Ваши эксклюзивные игровые награды уже ждут. Активируйте их сразу после пополнения.',
        activateNow: 'Активировать сейчас',
        reject: 'Жестокий отказ'
    },
    notification: {
        supportNoticesTab: 'Уведомления',
        supportTab: 'Поддержка',
        supportIntro: 'Нужна помощь? Свяжитесь с нашей командой по одному из следующих каналов.',
        liveChat: 'Начать онлайн-чат',
        navTitle: 'Центр сообщений',
        tabService: 'Сервис',
        tabInfo: 'Информация',
        tabNotice: 'Уведомления',
        tabAnnouncement: 'Объявления',
        serviceTitle: 'Онлайн-поддержка 24/7',
        serviceDesc: 'Служба поддержки готова помочь решить проблемы и ответить на ваши вопросы.',
        serviceButton: 'Поддержка 24/7',
        onlineChatTitle: 'Онлайн-служба поддержки',
        onlineChatDesc: 'Если вам нужна помощь, пожалуйста, свяжитесь со службой поддержки',
        service24Hours: 'Круглосуточная служба поддержки',
        contactNow: 'Связаться сейчас',
        officialGroupDesc: 'Присоединяйтесь к официальному игровому сообществу, чтобы получать последние новости об игре.',
        whatsappChannel: 'Официальный канал WhatsApp',
        telegramChannel: 'Официальный канал Telegram',
        instagramChannel: 'Официальный канал Instagram',
        joinNow: 'Присоединиться',
        ad1: '<p>Бонус за первый депозит до <span style=\'color: rgb(230, 0, 0);\'>20%</span>! Минимальный депозит - $20!</p>',
        ad2: '<p>Зарегистрируйтесь и скачайте приложение, чтобы выиграть крупные призы!</p>',
        ad3: '<p>Много привилегий при повышении до уровня <span style=\'color: rgb(230, 0, 0);\'>VIP! </span>Не забудьте ими воспользоваться!</p>',
        ad4: '<p>Награда за ежедневный check-in: чем больше вы пополняете счет, тем больше наград получаете!</p>',
        ad5: '<p data-v-f8490b69=\'\' class=\'ellipsis-1\'><p>Чем больше пополнений, тем больше бонусов! За второй депозит вы получите до <span style=\'color: rgb(230, 0, 0);\'>10%</span> бонуса. Наслаждайтесь игрой!</p></p>',
        ad6: '<p>Приглашайте друзей играть и выигрывайте миллионы! Получайте <span style=\'color: rgb(230, 0, 0);\'>$35</span> за каждого приглашенного друга.</p>',
        ad7: '<p>Правильный настрой - самое важное оружие на пути к успеху.</p>',
        defaultInfoTitle: 'Ваша регистрация успешно завершена',
        defaultInfoContent: '<p data-v-7e100e6c=\'\'><p>🎉 <strong>Регистрация прошла успешно!</strong></p><p>Добро пожаловать в <strong>XO GROUP 🎰</strong></p><p>Ваш аккаунт успешно создан - готовьтесь наслаждаться лучшими играми и выигрывать крупные призы! 💎</p><p>👉 <strong>Сделайте первый депозит и получите до 20% дополнительного бонуса.</strong> 🚀</p></p>'
    },
    sports: {
        title: 'Sports',
        home: 'Home'
    },
    weeklySalary: {
        back: 'Назад',
        heroTitle: 'VIP-пользователи, получите награды за повышение и еженедельную зарплату.',
        heroDesc: 'Пополните баланс, чтобы разблокировать щедрые награды и получить еженедельный бонус.',
        currentLevel: 'Текущий уровень:',
        sectionTitle: 'Награды за повышение',
        rulesHeading: 'Еженедельный VIP-бонус',
        rulesTitle: 'Правила мероприятия:',
        rule1: 'Каждую неделю вы будете получать эксклюзивную денежную награду в зависимости от вашего текущего VIP-уровня.',
        rule2: 'Чем выше ваш VIP-уровень, тем больше будет ваш еженедельный бонус.',
        rule3: 'Бонус можно получить каждую среду после 05:00 утра напрямую на ваш счет.',
        rule4: 'Это мероприятие действует только для обычных операций владельцев аккаунтов. Аренда аккаунтов, боты, множественные аккаунты, фиктивные сделки и арбитраж строго запрещены.',
        recordButton: 'История получения',
        recordSubtitle: 'История полученных еженедельных бонусов',
        claim: 'Получить',
        claimed: 'Получено',
        claimSuccess: 'Награда успешно получена',
        stampFinished: 'Завершено',
        stampLocked: 'Заблокировано',
        stampAvailable: 'Доступно',
        completed: 'Выполнено',
        sent: 'Отправлено',
        recordEntry: 'Еженедельная зарплата',
        levelLabelCurrent: 'Текущий уровень',
        levelLabelUpgrade: 'Первое повышение VIP',
        levelLabelWeekly: 'Еженедельная награда',
        levelLabelPremium: 'Премиум-бонус',
        levelLabelTop: 'Максимальная зарплата',
        navTitle: 'VIP-зарплата',
        tableLevel: 'Уровень',
        tableUpgradeRewards: 'Награды уровня',
        tableWeeklySalary: 'Еженедельные зарплаты',
        detailRule3: 'Бонус можно получить каждый понедельник после 01:00 ночи напрямую на ваш счет.',
        detailRule4: 'Это мероприятие действует только для обычных операций владельца аккаунта. Строго запрещено использовать арендованные аккаунты, ботов, множественные аккаунты, взаимный майнинг, арбитраж, API или протоколы, эксплуатацию уязвимостей или управление группами. В противном случае награда может быть отменена или списана, а аккаунт может быть заморожен или даже навсегда заблокирован.',
        detailRule5: 'Во избежание недоразумений при толковании текста платформа оставляет за собой окончательное право интерпретации данного мероприятия.',
        recordNavTitle: 'VIP-награды',
        recordTabUpgrade: 'Награда уровня',
        recordTabWeekly: 'Еженедельная зарплата',
        recordTableVipLevel: 'VIP-уровень',
        recordTableUpgradeAmount: 'Награды за повышение',
        recordTableWeeklyAmount: 'Зарплата',
        recordTableTime: 'Время',
        rescueRecordNavTitle: 'Компенсация убытков',
        rescueRecordTabDaily: 'Ежедневная помощь',
        rescueRecordTabWeekly: 'Еженедельная помощь',
        rescueRecordTableVipLevel: 'VIP-уровень',
        rescueRecordTableFunds: 'Сумма компенсации',
        rescueRecordTableTime: 'Время',
        upBonusTitle: 'Super reward',
        upBonusDesc1: 'Currently you can claim a regular reward of',
        upBonusDesc2: 'but by depositing',
        upBonusDesc3: 'you can claim a super bonus of',
        upBonusSuperDouble: 'Super double',
        upBonusCommon: 'Common'
    },
    weeklyRescue: {
        navTitle: 'Компенсация убытков',
        dailyTab: 'Ежедневная помощь',
        weeklyTab: 'Еженедельная помощь',
        dailyTitle: 'Сегодняшняя субсидия',
        weeklyTitle: 'Субсидия этой недели',
        dailyDesc: 'Получить можно на следующий день в {time}.',
        weeklyDesc: 'Получить можно в понедельник в {time} утром.',
        level: 'Уровень',
        lossAmount: 'Сумма потерь',
        subsidy: 'Субсидия',
        recordButton: 'История получения',
        yesterdaySubsidy: 'Yesterday subsidy',
        lastWeekSubsidy: 'Last week subsidy',
        redeemSuccessTitle: 'Redeemed successfully',
        redeemSuccessMessage: 'Get {currencyType} {amount}',
        confirmButton: 'Confirm'
    },
    socialMedia: {
        socialMedia: 'социальные сети'
    },
    claimRedEnvelope: {
        Envelope: 'Конверт',
        totalTips1: 'Депозит ',
        totalTips2: ' сегодня для участия. Вы внесли депозит на сумму ',
        totalTips3: 'Сделайте ставку ',
        totalTips4: ' сегодня для участия. Вы сделали ',
        totalTips5: ' ставку.',
        totalTips6: 'Максимальный лимит на этот раунд красных конвертов составляет ',
        totalTips7: ' раз',
        totalTips8: 'Это ',
        totalTips9: '-й красный конверт',
        Claimed: 'Получено',
        late: 'Опоздали',
        enter: 'Войти',
        getSuccTitle: 'Поздравляем',
        getSuccContent: 'получили',
        YouCanGet: 'Случайно получено ',
        noticeLabel: 'Список красных конвертов:',
        eventOver: 'Мероприятие завершено',
        eventStart: 'Акция проходит',
        needTips1: 'Сделайте депозит на сумму {amount} сегодня, чтобы получить этот красный конверт.',
        needTips2: 'Сделайте ставку на {amount} сегодня, чтобы получить этот красный конверт.',
        needTips3: 'Условия не выполнены',
        needTips4: 'Вы не соответствуете критериям для получения вознаграждения',
        upTips1: 'Теперь вы можете получить небольшой красный конверт. Внесите {upAmount}, чтобы получить крупный конверт с дополнительными наградами.',
        upTips3: 'Внесите {amount}, чтобы получить небольшой красный конверт; внесите {upAmount} для получения более крупного конверта с лучшими наградами.',
        upTips6: 'Сделайте ставку на {amount}, чтобы получить небольшой красный конверт; внесите {upAmount} для получения более крупного конверта с повышенными наградами.',
        upTips7: 'Получите красный конверт с наградой за обновление сейчас:',
        UpgradeRedEnvelope: 'Улучшить красный конверт',
        RegularRedEnvelope: 'Обычный красный конверт',
        DepositedBalance: 'Зачислено на баланс',
        redPacketTitle: 'Поздравляем! Вы получили бонус в красном конверте.'
    }
}
